// import { useState, useEffect, useRef } from "react";

// const T = {
//   en: {
//     nav: ["Story", "For Students", "For Vendors", "Attendance", "Download"],
//     langLabel: ["EN", "HI", "MR"],
//     hero: {
//       eyebrow: "Pune · Maharashtra · India",
//       line1: "The Menu",
//       line2: "Comes to You.",
//       sub: "SwaadIndia was born from a simple truth — no student should have to walk across campus only to discover the mess is serving something they didn't want. We bring the menu to you, in real time.",
//       cta: "Discover the App",
//       scroll: "Scroll to explore",
//     },
//     story: {
//       label: "Our Purpose",
//       h: "Built for the\nEveryday Student.",
//       p1: "Every morning in Pune, thousands of students and bachelors begin the same ritual — a walk to the mess, a squint at a chalk-board menu, a shrug. SwaadIndia ends that ritual.",
//       p2: "We connect students to their mess in real time. Browse menus, subscribe to meal plans, track your days, pause when you go home — all without leaving your room.",
//       pull: "\"The menu, delivered before you even feel hungry.\"",
//     },
//     studentFeatures: {
//       label: "For Students & Bachelors",
//       h: "Everything at\nYour Fingertips.",
//       items: [
//         { n: "01", t: "Search by Area", d: "Find every mess and tiffin in your neighbourhood across Pune. Area-based, instant." },
//         { n: "02", t: "Veg · Non-Veg Filter", d: "Pure vegetarian or non-veg — filter in a single tap and see only what suits you." },
//         { n: "03", t: "Live Menu Updates", d: "Today's rice plate, the special thali — updated by vendors the moment they decide." },
//         { n: "04", t: "30-Day Subscriptions", d: "Subscribe to a mess plan for lunch or dinner. Cancel or pause at any time." },
//         { n: "05", t: "Pause Your Plan", d: "Heading home for a week? Pause your subscription and every day is preserved." },
//         { n: "06", t: "Favourites & Profile", d: "Save your favourite mess, view your history, and manage your profile with ease." },
//       ],
//     },
//     vendorFeatures: {
//       label: "For Mess Owners",
//       h: "Run Your Mess\nWith Precision.",
//       items: [
//         { n: "01", t: "Live Dashboard", d: "Daily inquiry counts, active subscribers, serving mode toggle — all in one glance." },
//         { n: "02", t: "Post Today's Menu", d: "Add the daily menu, the special rice plate, today's thali — customers see it instantly." },
//         { n: "03", t: "Special Menu", d: "Announce a festival special or a limited thali to draw customers before they decide." },
//         { n: "04", t: "Subscription Management", d: "Every customer plan, every renewal, every pause — managed from a single clean screen." },
//         { n: "05", t: "Menu History & Reports", d: "Track what you served, analyse what sold, download your monthly performance report." },
//         { n: "06", t: "Attendance Tracking", d: "QR-based check-in tells you exactly who came, when, and how often." },
//       ],
//     },
//     attendance: {
//       label: "Attendance System",
//       h: "QR Check-In.\nZero Paper.",
//       p: "A mess is a relationship — between owner and guest, built on trust and repetition. SwaadIndia's attendance system makes that relationship visible, measurable, and automatic.",
//       steps: [
//         { n: "I", t: "Generate", d: "Each mess receives a unique QR code from the vendor dashboard." },
//         { n: "II", t: "Scan", d: "Customer arrives, scans the code. Attendance is logged in under a second." },
//         { n: "III", t: "Track", d: "Vendor sees who came today, this week, this month — in real time." },
//         { n: "IV", t: "Report", d: "Monthly attendance reports are generated automatically for billing and review." },
//       ],
//     },
//     download: {
//       label: "Begin",
//       h: "Swaad awaits.",
//       sub: "Join students and mess owners across Pune who have already changed the way they eat.",
//       android: "Download for Android",
//       ios: "Download for iOS",
//       footer: "Free to download · Available in English, Hindi & Marathi",
//     },
//   },
//   hi: {
//     nav: ["कहानी", "छात्रों के लिए", "वेंडर के लिए", "उपस्थिति", "डाउनलोड"],
//     langLabel: ["EN", "HI", "MR"],
//     hero: {
//       eyebrow: "पुणे · महाराष्ट्र · भारत",
//       line1: "मेनू आपके",
//       line2: "पास आता है।",
//       sub: "SwaadIndia एक सरल सत्य से जन्मा — कोई भी छात्र यह जानने के लिए मेस तक न चले कि आज क्या बना है। हम मेनू आपके पास, रियल टाइम में लाते हैं।",
//       cta: "ऐप खोजें",
//       scroll: "नीचे स्क्रॉल करें",
//     },
//     story: {
//       label: "हमारा उद्देश्य",
//       h: "हर रोज के\nछात्र के लिए।",
//       p1: "हर सुबह पुणे में हजारों छात्र उसी रस्म से शुरू करते हैं — मेस तक चलना, बोर्ड पर मेनू देखना, और कंधे उचकाना। SwaadIndia इस रस्म को खत्म करता है।",
//       p2: "हम छात्रों को उनके मेस से रियल टाइम में जोड़ते हैं। मेनू देखें, मील प्लान सब्सक्राइब करें, दिन ट्रैक करें, घर जाते वक्त पॉज करें।",
//       pull: "\"मेनू, भूख लगने से पहले ही आपके पास।\"",
//     },
//     studentFeatures: {
//       label: "छात्रों और बैचलर्स के लिए",
//       h: "सब कुछ आपकी\nउंगलियों पर।",
//       items: [
//         { n: "01", t: "एरिया से सर्च", d: "पुणे में अपने आस-पास हर मेस और टिफिन खोजें।" },
//         { n: "02", t: "वेज · नॉन-वेज फिल्टर", d: "एक टैप में फिल्टर करें और सिर्फ अपनी पसंद का देखें।" },
//         { n: "03", t: "लाइव मेनू अपडेट", d: "आज का राइस प्लेट, स्पेशल थाली — वेंडर जैसे ही तय करे, आपको मिले।" },
//         { n: "04", t: "30-दिन सब्सक्रिप्शन", d: "लंच या डिनर प्लान सब्सक्राइब करें। कभी भी रद्द या पॉज करें।" },
//         { n: "05", t: "प्लान पॉज करें", d: "एक हफ्ते घर जा रहे हैं? सब्सक्रिप्शन पॉज करें, हर दिन सुरक्षित।" },
//         { n: "06", t: "फेवरेट और प्रोफाइल", d: "पसंदीदा मेस सेव करें, इतिहास देखें, प्रोफाइल मैनेज करें।" },
//       ],
//     },
//     vendorFeatures: {
//       label: "मेस मालिकों के लिए",
//       h: "अपना मेस\nसटीकता से चलाएं।",
//       items: [
//         { n: "01", t: "लाइव डैशबोर्ड", d: "आज की इन्क्वायरी, एक्टिव सब्सक्राइबर, सर्विंग मोड — एक नजर में।" },
//         { n: "02", t: "आज का मेनू पोस्ट करें", d: "डेली मेनू, राइस प्लेट, थाली जोड़ें — ग्राहक तुरंत देखें।" },
//         { n: "03", t: "स्पेशल मेनू", d: "फेस्टिवल स्पेशल या लिमिटेड थाली अनाउंस करें।" },
//         { n: "04", t: "सब्सक्रिप्शन मैनेजमेंट", d: "हर ग्राहक का प्लान, रिन्यूअल, पॉज — एक स्क्रीन से।" },
//         { n: "05", t: "मेनू हिस्ट्री और रिपोर्ट", d: "क्या परोसा, क्या बिका, मासिक रिपोर्ट डाउनलोड करें।" },
//         { n: "06", t: "उपस्थिति ट्रैकिंग", d: "QR चेक-इन से जानें कौन आया, कब आया, कितनी बार।" },
//       ],
//     },
//     attendance: {
//       label: "उपस्थिति प्रणाली",
//       h: "QR चेक-इन।\nकागज रहित।",
//       p: "मेस एक रिश्ता है — मालिक और ग्राहक के बीच, विश्वास और दोहराव पर बना। SwaadIndia इस रिश्ते को दृश्यमान, मापनीय और स्वचालित बनाता है।",
//       steps: [
//         { n: "I", t: "QR बनाएं", d: "हर मेस को वेंडर डैशबोर्ड से यूनिक QR कोड मिलता है।" },
//         { n: "II", t: "स्कैन करें", d: "ग्राहक आता है, QR स्कैन करता है। एक सेकंड में उपस्थिति दर्ज।" },
//         { n: "III", t: "ट्रैक करें", d: "वेंडर रियल टाइम में देखता है — आज, इस हफ्ते, इस महीने कौन आया।" },
//         { n: "IV", t: "रिपोर्ट", d: "मासिक उपस्थिति रिपोर्ट बिलिंग के लिए स्वचालित रूप से बनती है।" },
//       ],
//     },
//     download: {
//       label: "शुरू करें",
//       h: "स्वाद इंतजार करता है।",
//       sub: "पुणे के उन छात्रों और मेस मालिकों से जुड़ें जिन्होंने पहले ही खाने का तरीका बदल दिया।",
//       android: "Android के लिए डाउनलोड करें",
//       ios: "iOS के लिए डाउनलोड करें",
//       footer: "डाउनलोड मुफ्त · English, Hindi और Marathi में उपलब्ध",
//     },
//   },
//   mr: {
//     nav: ["कथा", "विद्यार्थ्यांसाठी", "विक्रेत्यांसाठी", "हजेरी", "डाउनलोड"],
//     langLabel: ["EN", "HI", "MR"],
//     hero: {
//       eyebrow: "पुणे · महाराष्ट्र · भारत",
//       line1: "मेनू येतो",
//       line2: "तुमच्यापाशी।",
//       sub: "SwaadIndia एका साध्या सत्यातून जन्मला — कोणत्याही विद्यार्थ्याने आज काय आहे हे जाणण्यासाठी मेसपर्यंत चालत जाऊ नये. आम्ही मेनू तुमच्यापर्यंत, रिअल टाइममध्ये पोहोचवतो.",
//       cta: "ॲप शोधा",
//       scroll: "खाली स्क्रोल करा",
//     },
//     story: {
//       label: "आमचा उद्देश",
//       h: "रोजच्या\nविद्यार्थ्यासाठी.",
//       p1: "दररोज सकाळी पुण्यात हजारो विद्यार्थी त्याच विधीने सुरुवात करतात — मेसकडे चालणे, फळ्यावरचा मेनू बघणे, खांदे उडवणे. SwaadIndia हा विधी संपवतो.",
//       p2: "आम्ही विद्यार्थ्यांना त्यांच्या मेसशी रिअल टाइममध्ये जोडतो. मेनू पाहा, जेवण योजना सबस्क्राइब करा, दिवस ट्रॅक करा, घरी गेल्यावर थांबवा.",
//       pull: "\"मेनू, भूक लागण्यापूर्वीच तुमच्यापाशी.\"",
//     },
//     studentFeatures: {
//       label: "विद्यार्थी आणि बॅचलर्ससाठी",
//       h: "सर्व काही तुमच्या\nबोटांवर.",
//       items: [
//         { n: "01", t: "परिसरानुसार शोध", d: "पुण्यात तुमच्या जवळचे प्रत्येक मेस आणि टिफिन शोधा." },
//         { n: "02", t: "व्हेज · नॉन-व्हेज फिल्टर", d: "एका टॅपमध्ये फिल्टर करा आणि फक्त तुमच्या पसंतीचे पाहा." },
//         { n: "03", t: "लाइव्ह मेनू अपडेट्स", d: "आजचे राइस प्लेट, स्पेशल थाळी — विक्रेता ठरवताच तुम्हाला मिळते." },
//         { n: "04", t: "30-दिवसांची सबस्क्रिप्शन", d: "लंच किंवा डिनर योजना सबस्क्राइब करा. कधीही रद्द किंवा थांबवा." },
//         { n: "05", t: "योजना थांबवा", d: "एक आठवडा घरी जाताय? सबस्क्रिप्शन थांबवा, प्रत्येक दिवस जपला जातो." },
//         { n: "06", t: "आवडते आणि प्रोफाइल", d: "आवडते मेस जतन करा, इतिहास पाहा, प्रोफाइल व्यवस्थापित करा." },
//       ],
//     },
//     vendorFeatures: {
//       label: "मेस मालकांसाठी",
//       h: "तुमचे मेस\nअचूकतेने चालवा.",
//       items: [
//         { n: "01", t: "लाइव्ह डॅशबोर्ड", d: "आजच्या चौकशी, सक्रिय सबस्क्रायबर, सर्व्हिंग मोड — एका नजरेत." },
//         { n: "02", t: "आजचे मेनू पोस्ट करा", d: "दैनंदिन मेनू, राइस प्लेट, थाळी जोडा — ग्राहक लगेच पाहतात." },
//         { n: "03", t: "स्पेशल मेनू", d: "सण स्पेशल किंवा मर्यादित थाळी जाहीर करा." },
//         { n: "04", t: "सबस्क्रिप्शन व्यवस्थापन", d: "प्रत्येक ग्राहकाची योजना, नूतनीकरण, विराम — एका स्क्रीनवरून." },
//         { n: "05", t: "मेनू इतिहास आणि अहवाल", d: "काय वाढले, काय विकले, मासिक अहवाल डाउनलोड करा." },
//         { n: "06", t: "हजेरी ट्रॅकिंग", d: "QR चेक-इनने जाणा कोण आले, केव्हा आले, किती वेळा." },
//       ],
//     },
//     attendance: {
//       label: "हजेरी प्रणाली",
//       h: "QR चेक-इन.\nकागदरहित.",
//       p: "मेस म्हणजे एक नाते — मालक आणि पाहुण्यांमधील, विश्वास आणि पुनरावृत्तीवर बांधलेले. SwaadIndia हे नाते दृश्यमान, मोजण्यायोग्य आणि स्वयंचलित बनवतो.",
//       steps: [
//         { n: "I", t: "QR तयार करा", d: "प्रत्येक मेसला विक्रेता डॅशबोर्डवरून युनिक QR कोड मिळतो." },
//         { n: "II", t: "स्कॅन करा", d: "ग्राहक येतो, QR स्कॅन करतो. एका सेकंदात हजेरी नोंदवली जाते." },
//         { n: "III", t: "ट्रॅक करा", d: "विक्रेता रिअल टाइममध्ये पाहतो — आज, या आठवड्यात, या महिन्यात कोण आले." },
//         { n: "IV", t: "अहवाल", d: "मासिक हजेरी अहवाल बिलिंगसाठी आपोआप तयार होतो." },
//       ],
//     },
//     download: {
//       label: "सुरुवात करा",
//       h: "स्वाद वाट पाहत आहे.",
//       sub: "पुण्यातील त्या विद्यार्थ्यांमध्ये सामील व्हा ज्यांनी आधीच जेवणाची पद्धत बदलली आहे.",
//       android: "Android साठी डाउनलोड करा",
//       ios: "iOS साठी डाउनलोड करा",
//       footer: "डाउनलोड मोफत · English, Hindi आणि Marathi मध्ये उपलब्ध",
//     },
//   },
// };

// const LANG_CODES = ["en", "hi", "mr"];
// const C = {
//   cream: "#F7F3ED",
//   parchment: "#EDE6DA",
//   dark: "#1C1410",
//   charcoal: "#231A12",

//   spice: "#6B4423",     // darker = better readability
//   gold: "#B8965E",      // slightly deeper
//   saffron: "#C46A1F",   // less washed out

//   muted: "#5A4D3F",     // 🔥 more visible text
//   line: "#CFC4B6",      // slightly darker borders
// };

// function useInView(threshold = 0.12) {
//   const ref = useRef(null);
//   const [vis, setVis] = useState(false);
//   useEffect(() => {
//     const el = ref.current; if (!el) return;
//     const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVis(true); obs.disconnect(); } }, { threshold });
//     obs.observe(el);
//     return () => obs.disconnect();
//   }, [threshold]);
//   return [ref, vis];
// }

// function Reveal({ children, delay = 0, y = 28, style = {} }) {
//   const [ref, vis] = useInView();
//   return (
//     <div ref={ref} style={{
//       opacity: vis ? 1 : 0,
//       transform: vis ? "translateY(0)" : `translateY(${y}px)`,
//       transition: `opacity 1s cubic-bezier(.22,1,.36,1) ${delay}s, transform 1s cubic-bezier(.22,1,.36,1) ${delay}s`,
//       ...style,
//     }}>{children}</div>
//   );
// }

// function Ornament() {
//   return (
//     <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
//       <circle cx="14" cy="14" r="2" fill={C.gold} />
//       <line x1="14" y1="2" x2="14" y2="9" stroke={C.gold} strokeWidth="1" />
//       <line x1="14" y1="19" x2="14" y2="26" stroke={C.gold} strokeWidth="1" />
//       <line x1="2" y1="14" x2="9" y2="14" stroke={C.gold} strokeWidth="1" />
//       <line x1="19" y1="14" x2="26" y2="14" stroke={C.gold} strokeWidth="1" />
//       <circle cx="14" cy="14" r="6" stroke={C.gold} strokeWidth="0.75" />
//     </svg>
//   );
// }

// function FeatureCell({ n, t: title, d, dark = false }) {
//   const [hover, setHover] = useState(false);
//   return (
//     <div
//       onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)}
//       style={{
//         borderRight: `1px solid ${dark ? "rgba(201,168,124,0.18)" : C.line}`,
//         borderBottom: `1px solid ${dark ? "rgba(201,168,124,0.18)" : C.line}`,
//         padding: "36px 30px",
//         background: dark ? (hover ? "rgba(247,243,237,0.06)" : "transparent") : (hover ? C.parchment : "transparent"),
//         transition: "background 0.4s", cursor: "default",
//       }}>
//       <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 40, fontWeight: 400, color: dark ? "rgba(201,168,124,0.25)" : C.line, lineHeight: 1, marginBottom: 14 }}>{n}</div>
//       <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 19, fontWeight: 400, color: hover ? (dark ? C.gold : C.spice) : (dark ? "#F7F3ED" : C.dark), marginBottom: 9, transition: "color 0.3s" }}>{title}</div>
//       <div style={{ fontFamily: "'Jost', sans-serif", fontWeight: 400, fontSize: 14, lineHeight: 1.75, color: dark ? "rgba(247,243,237,0.42)" : "#4A3F35" }}>{d}</div>
//     </div>
//   );
// }

// function DlBtn({ label, icon, primary }) {
//   const [hover, setHover] = useState(false);
//   return (
//     <button onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)} style={{
//       display: "flex", alignItems: "center", gap: 12,
//       background: primary ? (hover ? C.gold : C.saffron) : (hover ? "rgba(247,243,237,0.07)" : "transparent"),
//       border: primary ? "none" : "1px solid rgba(247,243,237,0.22)",
//       color: primary ? "#fff" : "rgba(247,243,237,0.75)",
//       padding: "17px 36px",
//       fontFamily: "'Jost', sans-serif", fontWeight: 400, fontSize: 12,
//       letterSpacing: "0.18em", textTransform: "uppercase", cursor: "pointer", transition: "all 0.35s",
//     }}>
//       <span style={{ fontSize: 18 }}>{icon}</span>{label}
//     </button>
//   );
// }

// export default function App() {
//   const [lang, setLang] = useState("en");
//   const [scrollY, setScrollY] = useState(0);
//   const t = T[lang];
//   const navSolid = scrollY > 60;

//   useEffect(() => {
//     const fn = () => setScrollY(window.scrollY);
//     window.addEventListener("scroll", fn, { passive: true });
//     return () => window.removeEventListener("scroll", fn);
    
//   }, []);

//   useEffect(() => {
//     const s = document.createElement("style");
    
//     s.textContent = `
//       @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Jost:wght@300;400;500&display=swap');
//       html{scroll-behavior:smooth}*{margin:0;padding:0;box-sizing:border-box}
//       body{background:#F7F3ED;color:#1C1410;font-family:'Jost',sans-serif;overflow-x:hidden}
//       ::selection{background:#8B5E3C33}
//       ::-webkit-scrollbar{width:3px}::-webkit-scrollbar-track{background:#F7F3ED}::-webkit-scrollbar-thumb{background:#C9A87C}
//     `;
//     document.head.appendChild(s);
//     return () => document.head.removeChild(s);
    
//   }, []);
  

//   const scrollTo = id => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <div style={{ background: C.cream, color: C.dark, fontFamily: "'Jost',sans-serif", overflowX: "hidden" }}>

//       {/* NAV */}
//       <nav style={{
//         position: "fixed", top: 0, left: 0, right: 0, zIndex: 200,
//         padding: "0 5%", height: 70,
//         display: "flex", alignItems: "center", justifyContent: "space-between",
//         background: navSolid ? "rgba(247,243,237,0.95)" : "transparent",
//         backdropFilter: navSolid ? "blur(18px)" : "none",
//         borderBottom: navSolid ? `1px solid ${C.line}` : "none",
//         transition: "all 0.5s ease",
//       }}>
//         <button onClick={() => scrollTo("hero")} style={{ background: "none", border: "none", cursor: "pointer", textAlign: "left" }}>
//           <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, fontWeight: 600, color: C.dark, letterSpacing: "0.04em", lineHeight: 1 }}>
//             Swaad<span style={{ color: C.saffron }}>India</span>
//           </div>
//           <div style={{ fontSize: 9, fontWeight: 400, color: "#4A3F35", letterSpacing: "0.22em", textTransform: "uppercase", marginTop: 2 }}>Pune · Est. 2026</div>
//         </button>

//         <div style={{ display: "flex", alignItems: "center", gap: 32 }}>
//           {["story","students","vendors","attendance","download"].map((id, i) => (
//             <button key={id} onClick={() => scrollTo(id)} style={{
//               background: "none", border: "none", cursor: "pointer",
//               fontFamily: "'Jost',sans-serif", fontWeight: 400, fontSize: 12,
//               letterSpacing: "0.18em", textTransform: "uppercase", color: "#4A3F35", transition: "color 0.3s",
//             }}
//               onMouseOver={e => e.target.style.color = C.spice}
//               onMouseOut={e => e.target.style.color = C.muted}
//             >{t.nav[i]}</button>
//           ))}
//           <div style={{ display: "flex", gap: 2, borderLeft: `1px solid ${C.line}`, paddingLeft: 18 }}>
//             {LANG_CODES.map((code, i) => (
//               <button key={code} onClick={() => setLang(code)} style={{
//                 background: "none", border: "none", cursor: "pointer",
//                 fontFamily: "'Jost',sans-serif", fontWeight: lang === code ? 500 : 400, fontSize: 11,
//                 letterSpacing: "0.1em", padding: "4px 8px",
//                 color: lang === code ? C.saffron : C.muted,
//                 borderBottom: `1px solid ${lang === code ? C.saffron : "transparent"}`,
//                 transition: "all 0.25s",
//               }}>{t.langLabel[i]}</button>
//             ))}
//           </div>
//         </div>
//       </nav>

//       {/* HERO */}
//       <section id="hero" style={{ minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", padding: "120px 5% 100px", position: "relative", overflow: "hidden" }}>
//         <div style={{ position: "absolute", top: 70, left: "5%", right: "5%", height: 1, background: C.line }} />
//         {/* Watermark */}
//         <div style={{
//           position: "absolute", bottom: -20, right: -10,
//           fontFamily: "'Cormorant Garamond',serif", fontSize: "min(280px, 30vw)",
//           fontWeight: 400, lineHeight: 0.85, color: "transparent",
//           WebkitTextStroke: `1px ${C.line}`, pointerEvents: "none",
//           opacity: Math.max(0, 1 - scrollY / 500), letterSpacing: "-0.03em",
//         }}>स्वाद</div>

//         <div style={{ maxWidth: 1200, width: "100%", margin: "0 auto" }}>
//           <Reveal delay={0.1}>
//             <p style={{ fontSize: 11, fontWeight: 400, letterSpacing: "0.28em", textTransform: "uppercase", color: "#4A3F35", marginBottom: 44 }}>{t.hero.eyebrow}</p>
//           </Reveal>
//           <Reveal delay={0.22}>
//             <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 400, fontSize: "clamp(60px, 10vw, 140px)", lineHeight: 0.9, letterSpacing: "-0.03em", marginBottom: 4 }}>
//               {t.hero.line1}
//             </h1>
//             <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 400, fontStyle: "italic", fontSize: "clamp(60px, 10vw, 140px)", lineHeight: 0.9, letterSpacing: "-0.03em", color: C.saffron, marginBottom: 52 }}>
//               {t.hero.line2}
//             </h1>
//           </Reveal>
//           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48, alignItems: "flex-end" }}>
//             <Reveal delay={0.38}>
//               <p style={{ fontFamily: "'Jost',sans-serif", fontWeight: 400, fontSize: 17, lineHeight: 1.9, color: "#4A3F35", maxWidth: 440 }}>{t.hero.sub}</p>
//             </Reveal>
//             <Reveal delay={0.5} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 20 }}>
//               <button onClick={() => scrollTo("story")} style={{
//                 fontFamily: "'Jost',sans-serif", fontWeight: 400, fontSize: 12,
//                 letterSpacing: "0.22em", textTransform: "uppercase", color: C.dark,
//                 background: "none", border: `1px solid ${C.dark}`, padding: "17px 42px",
//                 cursor: "pointer", transition: "all 0.4s",
//               }}
//                 onMouseOver={e => { e.target.style.background = C.dark; e.target.style.color = C.cream; }}
//                 onMouseOut={e => { e.target.style.background = "none"; e.target.style.color = C.dark; }}
//               >{t.hero.cta}</button>
//               <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//                 <div style={{ width: 36, height: 1, background: C.muted }} />
//                 <span style={{ fontSize: 10, fontWeight: 400, letterSpacing: "0.18em", textTransform: "uppercase", color: "#4A3F35" }}>{t.hero.scroll}</span>
//               </div>
//             </Reveal>
//           </div>
//         </div>

//         {/* Stats */}
//         <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, borderTop: `1px solid ${C.line}`, display: "flex", justifyContent: "center" }}>
//           {[["500+","Mess Partners"],["10,000+","Students"],["3","Cities Live"]].map(([n,l],i) => (
//             <div key={l} style={{ padding: "18px 56px", borderLeft: i > 0 ? `1px solid ${C.line}` : "none", textAlign: "center" }}>
//               <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 24, fontWeight: 400, color: C.saffron }}>{n}</div>
//               <div style={{ fontSize: 9, fontWeight: 400, letterSpacing: "0.22em", textTransform: "uppercase", color: C.muted, marginTop: 3 }}>{l}</div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* STORY */}
//       <section id="story" style={{ padding: "130px 5%", background: C.parchment, position: "relative" }}>
//         <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 1, background: C.line }} />
//         <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 2fr", gap: 90, alignItems: "flex-start" }}>
//           <Reveal>
//             <p style={{ fontSize: 9, fontWeight: 400, letterSpacing: "0.32em", textTransform: "uppercase", color: C.gold, marginBottom: 22 }}>{t.story.label}</p>
//             <Ornament />
//             <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 400, fontSize: "clamp(36px, 4.5vw, 56px)", lineHeight: 1.08, letterSpacing: "-0.02em", marginTop: 18, whiteSpace: "pre-line" }}>{t.story.h}</h2>
//           </Reveal>
//           <div style={{ paddingTop: 12 }}>
//             <Reveal delay={0.12}><p style={{ fontFamily: "'Jost',sans-serif", fontWeight: 400, fontSize: 18, lineHeight: 1.9, color: C.charcoal, marginBottom: 24 }}>{t.story.p1}</p></Reveal>
//             <Reveal delay={0.22}><p style={{ fontFamily: "'Jost',sans-serif", fontWeight: 400, fontSize: 18, lineHeight: 1.9, color: C.charcoal, marginBottom: 44 }}>{t.story.p2}</p></Reveal>
//             <Reveal delay={0.32}>
//               <div style={{ borderLeft: `3px solid ${C.gold}`, paddingLeft: 26 }}>
//                 <p style={{ fontFamily: "'Cormorant Garamond',serif", fontStyle: "italic", fontSize: 24, fontWeight: 400, color: C.spice, lineHeight: 1.55 }}>{t.story.pull}</p>
//               </div>
//             </Reveal>
//           </div>
//         </div>
//       </section>

//       {/* DIVIDER */}
//       <div style={{ padding: "48px 5%", background: C.cream, display: "flex", alignItems: "center", justifyContent: "center", gap: 18, borderTop: `1px solid ${C.line}`, borderBottom: `1px solid ${C.line}` }}>
//         <div style={{ height: 1, flex: 1, background: C.line }} />
//         <span style={{ fontSize: 24, letterSpacing: "0.35em" }}>🍛 · 🥗 · 🍱</span>
//         <div style={{ height: 1, flex: 1, background: C.line }} />
//       </div>

//       {/* STUDENTS */}
//       <section id="students" style={{ padding: "130px 5%", background: C.cream }}>
//         <div style={{ maxWidth: 1100, margin: "0 auto" }}>
//           <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 72, alignItems: "flex-start", marginBottom: 72 }}>
//             <Reveal>
//               <p style={{ fontSize: 9, letterSpacing: "0.32em", textTransform: "uppercase", color: C.gold, marginBottom: 18 }}>{t.studentFeatures.label}</p>
//               <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 400, fontSize: "clamp(36px, 4.5vw, 60px)", lineHeight: 1.05, letterSpacing: "-0.02em", whiteSpace: "pre-line" }}>{t.studentFeatures.h}</h2>
//             </Reveal>
//             {/* App mockup */}
//             <Reveal delay={0.12}>
//               <div style={{ background: C.charcoal, borderRadius: 26, padding: 22, border: "1px solid rgba(255,255,255,0.04)" }}>
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
//                   <div>
//                     <div style={{ fontSize: 9, color: "rgba(247,243,237,0.35)", letterSpacing: "0.18em", textTransform: "uppercase", marginBottom: 3 }}>Good afternoon</div>
//                     <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, color: "#F7F3ED", fontWeight: 400 }}>Rahul 🙏</div>
//                   </div>
//                   <div style={{ width: 38, height: 38, borderRadius: "50%", background: C.saffron, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Cormorant Garamond',serif", fontSize: 17, color: "#fff" }}>R</div>
//                 </div>
//                 <div style={{ background: "rgba(247,243,237,0.05)", borderRadius: 10, padding: "10px 14px", marginBottom: 14, display: "flex", gap: 8, alignItems: "center" }}>
//                   <span style={{ fontSize: 13 }}>🔍</span>
//                   <span style={{ fontSize: 12, color: "rgba(247,243,237,0.28)", fontWeight: 400 }}>Search in Kothrud, Pune…</span>
//                 </div>
//                 <div style={{ display: "flex", gap: 7, marginBottom: 14, flexWrap: "wrap" }}>
//                   {["All","🥗 Veg","🍗 Non-Veg","Near Me"].map((f,i) => (
//                     <span key={f} style={{ fontSize: 10, padding: "4px 10px", borderRadius: 20, background: i===0 ? C.saffron : "rgba(247,243,237,0.06)", color: i===0 ? "#fff" : "rgba(247,243,237,0.5)", fontWeight: i===0 ? 500 : 400 }}>{f}</span>
//                   ))}
//                 </div>
//                 {[{n:"Shree Ganesh Mess",a:"Kothrud",p:"₹60",tag:"Pure Veg",tc:"#2ECC71"},{n:"Amchi Mumbai Tiffin",a:"Deccan",p:"₹75",tag:"Non-Veg",tc:C.saffron}].map(m => (
//                   <div key={m.n} style={{ background: "rgba(247,243,237,0.04)", border: "1px solid rgba(247,243,237,0.07)", borderRadius: 14, padding: "13px 15px", marginBottom: 9 }}>
//                     <div style={{ display: "flex", justifyContent: "space-between" }}>
//                       <div>
//                         <div style={{ fontSize: 13, fontFamily: "'Cormorant Garamond',serif", color: "#F7F3ED", marginBottom: 3 }}>{m.n}</div>
//                         <div style={{ fontSize: 10, color: "rgba(247,243,237,0.32)", marginBottom: 7 }}>📍 {m.a}</div>
//                         <span style={{ fontSize: 9, padding: "2px 9px", borderRadius: 20, background: `${m.tc}22`, color: m.tc, letterSpacing: "0.04em" }}>{m.tag}</span>
//                       </div>
//                       <div style={{ textAlign: "right" }}>
//                         <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, color: C.gold, fontWeight: 400 }}>{m.p}</div>
//                         <div style={{ fontSize: 9, color: "rgba(247,243,237,0.28)", marginTop: 3 }}>Today's menu</div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//                 <div style={{ background: `linear-gradient(135deg,${C.saffron}1A,${C.gold}0D)`, border: `1px solid ${C.saffron}44`, borderRadius: 14, padding: "13px 15px" }}>
//                   <div style={{ fontSize: 9, color: C.gold, letterSpacing: "0.22em", textTransform: "uppercase", marginBottom: 5 }}>Today's Special</div>
//                   <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 17, color: "#F7F3ED" }}>Sunday Thali</div>
//                   <div style={{ fontSize: 10, color: "rgba(247,243,237,0.4)", marginTop: 3, lineHeight: 1.65 }}>Dal Makhani · Paneer Butter · 4 Roti · Rice · Gulab Jamun</div>
//                   <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, color: C.gold, marginTop: 7 }}>₹120</div>
//                 </div>
//               </div>
//             </Reveal>
//           </div>
//           <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", borderTop: `1px solid ${C.line}`, borderLeft: `1px solid ${C.line}` }}>
//             {t.studentFeatures.items.map((f,i) => (
//               <Reveal key={f.t} delay={i*0.06}><FeatureCell {...f} /></Reveal>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* VENDORS */}
//       <section id="vendors" style={{ padding: "130px 5%", background: C.charcoal, position: "relative", overflow: "hidden" }}>
//         <div style={{ position: "absolute", top: -60, right: -60, width: 460, height: 460, borderRadius: "50%", border: "1px solid rgba(201,168,124,0.08)", pointerEvents: "none" }} />
//         <div style={{ maxWidth: 1100, margin: "0 auto" }}>
//           <div style={{ textAlign: "center", marginBottom: 72 }}>
//             <Reveal>
//               <p style={{ fontSize: 9, letterSpacing: "0.32em", textTransform: "uppercase", color: C.gold, marginBottom: 18 }}>{t.vendorFeatures.label}</p>
//               <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 400, fontSize: "clamp(38px, 6.5vw, 76px)", lineHeight: 1, letterSpacing: "-0.03em", color: "#F7F3ED", whiteSpace: "pre-line" }}>{t.vendorFeatures.h}</h2>
//             </Reveal>
//           </div>
//           <Reveal delay={0.1}>
//             <div style={{ background: "rgba(247,243,237,0.035)", border: "1px solid rgba(201,168,124,0.18)", borderRadius: 22, padding: 28, marginBottom: 56 }}>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, paddingBottom: 18, borderBottom: "1px solid rgba(201,168,124,0.12)" }}>
//                 <div>
//                   <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, color: "#F7F3ED", fontWeight: 400 }}>Vendor Dashboard</div>
//                   <div style={{ fontSize: 10, color: "rgba(247,243,237,0.3)", letterSpacing: "0.1em", marginTop: 2 }}>Wednesday · Pune</div>
//                 </div>
//                 <div style={{ display: "flex", gap: 9 }}>
//                   {["🟢 Open","Add Menu","Reports"].map((b,bi) => (
//                     <button key={b} style={{ background: bi===0 ? "rgba(46,204,113,0.12)" : "rgba(247,243,237,0.05)", border: `1px solid ${bi===0 ? "rgba(46,204,113,0.35)" : "rgba(247,243,237,0.1)"}`, color: bi===0 ? "#2ECC71" : "rgba(247,243,237,0.55)", borderRadius: 6, padding: "7px 14px", fontSize: 11, cursor: "pointer", fontFamily: "'Jost',sans-serif" }}>{b}</button>
//                   ))}
//                 </div>
//               </div>
//               <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 14 }}>
//                 {[{l:"Today's Inquiries",v:"47",c:C.saffron},{l:"Active Plans",v:"128",c:"#2ECC71"},{l:"Check-ins Today",v:"32",c:C.gold},{l:"Monthly Revenue",v:"₹38.4K",c:"#F7F3ED"}].map(s => (
//                   <div key={s.l} style={{ background: "rgba(247,243,237,0.035)", borderRadius: 12, padding: "18px 16px", border: "1px solid rgba(247,243,237,0.06)" }}>
//                     <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 32, color: s.c, fontWeight: 400 }}>{s.v}</div>
//                     <div style={{ fontSize: 10, color: "rgba(247,243,237,0.32)", marginTop: 5, letterSpacing: "0.04em" }}>{s.l}</div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </Reveal>
//           <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", borderTop: "1px solid rgba(201,168,124,0.18)", borderLeft: "1px solid rgba(201,168,124,0.18)" }}>
//             {t.vendorFeatures.items.map((f,i) => (
//               <Reveal key={f.t} delay={i*0.06}><FeatureCell {...f} dark /></Reveal>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ATTENDANCE */}
//       <section id="attendance" style={{ padding: "130px 5%", background: C.parchment, position: "relative" }}>
//         <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 1, background: C.line }} />
//         <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 90, alignItems: "flex-start" }}>
//           <div>
//             <Reveal>
//               <p style={{ fontSize: 9, letterSpacing: "0.32em", textTransform: "uppercase", color: C.gold, marginBottom: 18 }}>{t.attendance.label}</p>
//               <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 400, fontSize: "clamp(36px, 4.5vw, 58px)", lineHeight: 1.05, letterSpacing: "-0.02em", whiteSpace: "pre-line", marginBottom: 24 }}>{t.attendance.h}</h2>
//             </Reveal>
//             <Reveal delay={0.1}><p style={{ fontFamily: "'Jost',sans-serif", fontWeight: 400, fontSize: 16, lineHeight: 1.9, color: C.muted, marginBottom: 44 }}>{t.attendance.p}</p></Reveal>
//             <Reveal delay={0.2}>
//               <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
//                 <div style={{ width: 130, height: 130, background: C.cream, border: `2px solid ${C.gold}`, borderRadius: 14, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 5, boxShadow: `0 0 0 8px ${C.parchment},0 0 0 9px ${C.line}` }}>
//                   <div style={{ fontSize: 54, lineHeight: 1 }}>📱</div>
//                   <div style={{ fontSize: 8, color: C.spice, letterSpacing: "0.22em", textTransform: "uppercase", fontWeight: 400 }}>Scan to enter</div>
//                 </div>
//                 <div style={{ fontSize: 9, color: C.muted, letterSpacing: "0.18em", textTransform: "uppercase" }}>Swaad QR · Unique per mess</div>
//               </div>
//             </Reveal>
//           </div>
//           <div style={{ borderLeft: `1px solid ${C.line}`, paddingLeft: 56 }}>
//             {t.attendance.steps.map((s,i) => (
//               <Reveal key={s.n} delay={i*0.1}>
//                 <div style={{ paddingBottom: 32, marginBottom: 32, borderBottom: i < 3 ? `1px solid ${C.line}` : "none" }}>
//                   <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 44, fontWeight: 400, color: C.line, lineHeight: 1, marginBottom: 10 }}>{s.n}</div>
//                   <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, fontWeight: 400, color: C.dark, marginBottom: 7 }}>{s.t}</div>
//                   <div style={{ fontFamily: "'Jost',sans-serif", fontWeight: 400, fontSize: 14, color: C.muted, lineHeight: 1.75 }}>{s.d}</div>
//                 </div>
//               </Reveal>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* DOWNLOAD */}
//       <section id="download" style={{ padding: "160px 5%", background: C.dark, position: "relative", overflow: "hidden", textAlign: "center" }}>
//         <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", fontFamily: "'Cormorant Garamond',serif", fontSize: "min(360px, 28vw)", fontWeight: 400, color: "transparent", WebkitTextStroke: "1px rgba(201,168,124,0.07)", pointerEvents: "none", whiteSpace: "nowrap", letterSpacing: "-0.03em" }}>स्वाद</div>
//         <div style={{ position: "relative", maxWidth: 680, margin: "0 auto" }}>
//           <Reveal>
//             <p style={{ fontSize: 9, letterSpacing: "0.32em", textTransform: "uppercase", color: C.gold, marginBottom: 28 }}>{t.download.label}</p>
//             <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}><Ornament /></div>
//             <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 400, fontStyle: "italic", fontSize: "clamp(50px, 9vw, 110px)", lineHeight: 0.9, letterSpacing: "-0.03em", color: C.cream, marginBottom: 32 }}>{t.download.h}</h2>
//             <p style={{ fontFamily: "'Jost',sans-serif", fontWeight: 400, fontSize: 16, color: "rgba(247,243,237,0.46)", lineHeight: 1.85, marginBottom: 52 }}>{t.download.sub}</p>
//             <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap", marginBottom: 24 }}>
//               <DlBtn label={t.download.android} icon="🤖" primary />
//               <DlBtn label={t.download.ios} icon="🍎" />
//             </div>
//             <p style={{ fontSize: 10, color: "rgba(247,243,237,0.2)", letterSpacing: "0.15em", textTransform: "uppercase" }}>{t.download.footer}</p>
//           </Reveal>
//         </div>
//       </section>

//       {/* FOOTER */}
//       <footer style={{ background: "#0E0A06", borderTop: "1px solid rgba(201,168,124,0.12)", padding: "36px 5%", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 14 }}>
//         <div>
//           <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 18, fontWeight: 600, color: C.cream, letterSpacing: "0.04em" }}>Swaad<span style={{ color: C.saffron }}>India</span></span>
//           <span style={{ fontSize: 9, color: "rgba(247,243,237,0.18)", marginLeft: 14, letterSpacing: "0.2em", textTransform: "uppercase" }}>Pune · 2026</span>
//         </div>
//         <p style={{ fontSize: 11, color: "rgba(247,243,237,0.18)", fontWeight: 400 }}>Made with love for every hungry student in India.</p>
//         <div style={{ display: "flex", gap: 22 }}>
//           {["Privacy","Terms","Contact"].map(l => (
//             <span key={l} style={{ fontSize: 10, color: "rgba(247,243,237,0.22)", cursor: "pointer", letterSpacing: "0.12em", textTransform: "uppercase" }}>{l}</span>
//           ))}
//         </div>
//       </footer>
//     </div>
//   );
// }

import { useState, useEffect, useRef } from "react";

const C = {
  cream: "#eed8b6", parchment: "#f0dfc2", dark: "#1A120A", charcoal: "#231910",
  spice: "#8B5E3C", gold: "#C9A87C", saffron: "#D4863A", muted: "#7A6B5A",
  line: "#e9c995", green: "#2D7A3A", deepgreen: "#1C5225",
};

const T = {
  en: {
    nav: ["Story", "For Students", "For Vendors", "App", "Download"],
    langLabel: ["EN", "हि", "म"],
    hero: {
      eyebrow: "Pune · Maharashtra · India",
      tag: "When hunger strikes — SwaadIndia answers.",
      line1: "Before you feel hungry,",
      line2: "you already know\nwhat's cooking.",
      sub: "Every rice plate. Every thali. Every mess in Pune — updated live, delivered to your phone before you even think of stepping out.",
      cta: "See the App",
      scroll: "Discover our story",
    },
    taglines: [
      { q: "\"Walk. Check. Disappoint. Repeat.\"", a: "That ends today." },
      { q: "\"Rice plate kaay ahe aaj?\"", a: "Open SwaadIndia. Know in 3 seconds." },
      { q: "\"What's for lunch?\"", a: "The only answer is SwaadIndia." },
    ],
    story: {
      label: "The Story",
      chapters: [
        { n: "01", title: "The Walk Nobody Wants", body: "It's 12:30 PM. You're hungry. You walk to the mess — only to find they changed the menu, the shutters are half-down, and your roommate already knew from his phone. That roommate uses SwaadIndia." },
        { n: "02", title: "The Mess Owner's Frustration", body: "Sharma runs a mess in Kothrud. Every day, students ask him on WhatsApp — 'Kya banega aaj?' He types the same answer thirty times. Then he found SwaadIndia. One post. Thirty students informed. Done." },
        { n: "03", title: "The Idea That Changed Everything", body: "What if the menu came to you? What if you could subscribe, track days, pause when you go home — and the vendor could see who came, who didn't, and who owes him for the month? SwaadIndia was born." },
      ],
      pull: "\"The first thought before every rice plate — SwaadIndia.\"",
    },
    studentFeatures: {
      label: "For Students & Bachelors",
      h: "Your Mess,\nYour Rules.",
      tagline: "Because you deserve to know what's cooking before you leave your room.",
      features: [
        { n: "01", t: "Search by Area", d: "Find every mess and tiffin near you in Pune. One search. Instant results." },
        { n: "02", t: "Veg · Non-Veg Filter", d: "Filter in a tap. See only what suits your plate — pure veg or non-veg." },
        { n: "03", t: "Live Menu Updates", d: "Today's rice plate, special thali — updated the moment the vendor decides." },
        { n: "04", t: "30-Day Subscription", d: "Subscribe once. Eat every day. Track your days, pause anytime." },
        { n: "05", t: "Pause Your Plan", d: "Going home for a week? Pause — every unused day stays with you." },
        { n: "06", t: "Attendance History", d: "See exactly which days you ate, from which mess. Full transparency." },
      ],
    },
    vendorFeatures: {
      label: "For Mess Owners",
      h: "Run your mess\nlike a business.",
      tagline: "Stop managing on WhatsApp. Start managing on SwaadIndia.",
      features: [
        { n: "01", t: "Live Dashboard", d: "Inquiry count, serving mode toggle, active subscribers — one glance, full picture." },
        { n: "02", t: "Add Today's Menu", d: "Post your rice plate and thali once. Every subscriber sees it instantly." },
        { n: "03", t: "Special Menu", d: "Announce a festival thali or limited special — drive more footfall every time." },
        { n: "04", t: "Subscription Management", d: "Every customer's plan, renewal date, pause status — clean, one screen." },
        { n: "05", t: "Menu History & Reports", d: "What you served, what worked, monthly export — all automated." },
        { n: "06", t: "QR Attendance", d: "Customer scans, attendance marked. No registers. No chaos. Just data." },
      ],
    },
    attendance: {
      label: "Attendance System",
      h: "QR In.\nPaper Out.",
      tagline: "From a clipboard on the wall to a live dashboard on your phone.",
      steps: [
        { n: "I", t: "Generate QR", d: "Each mess gets its own unique QR code from the vendor dashboard." },
        { n: "II", t: "Customer Scans", d: "Customer arrives, scans the QR. Present — logged in under a second." },
        { n: "III", t: "Live View", d: "Vendor sees Expected / Present / Absent in real time. Breakfast, Lunch, Dinner." },
        { n: "IV", t: "Auto Report", d: "Monthly attendance report generated automatically. Export with one tap." },
      ],
    },
    download: {
      label: "Begin Now",
      h: "One thought.\nOne app.\nSwaadIndia.",
      sub: "Join thousands of students and hundreds of mess owners across Pune who never ask 'what's for lunch?' without knowing the answer.",
      android: "Download for Android",
      ios: "Download for iOS",
      footer: "Free · English · हिंदी · मराठी",
    },
  },
  hi: {
    nav: ["कहानी", "छात्रों के लिए", "वेंडर के लिए", "ऐप", "डाउनलोड"],
    langLabel: ["EN", "हि", "म"],
    hero: {
      eyebrow: "पुणे · महाराष्ट्र · भारत",
      tag: "जब भूख लगे — SwaadIndia जवाब देता है।",
      line1: "भूख लगने से पहले,",
      line2: "हम जानते हैं\nआज क्या बना है।",
      sub: "हर राइस प्लेट। हर थाली। पुणे का हर मेस — लाइव अपडेट, आपके फ़ोन पर, बाहर निकलने से पहले।",
      cta: "ऐप देखें",
      scroll: "हमारी कहानी जानें",
    },
    taglines: [
      { q: "\"चलो, चेक करो, निराश हो, दोहराओ।\"", a: "यह आज खत्म होता है।" },
      { q: "\"आज मेस में क्या बना है?\"", a: "SwaadIndia खोलो। 3 सेकंड में जानो।" },
      { q: "\"लंच में क्या है?\"", a: "जवाब हमेशा SwaadIndia है।" },
    ],
    story: {
      label: "कहानी",
      chapters: [
        { n: "01", title: "वो चलाई जो कोई नहीं चाहता", body: "दोपहर 12:30 बजे। भूख लगी है। मेस पहुंचते हो — मेनू बदल गया, शटर आधा बंद, और रूममेट पहले से जानता था। वो SwaadIndia इस्तेमाल करता है।" },
        { n: "02", title: "मेस मालिक की परेशानी", body: "मोहन कोथरुड में मेस चलाता है। हर दिन WhatsApp पर यही पूछते हैं — 'आज क्या बनेगा?' वो तीस बार एक जवाब टाइप करता था। फिर SwaadIndia मिला। एक पोस्ट। तीस छात्र सूचित। खत्म।" },
        { n: "03", title: "वो आइडिया जिसने सब बदला", body: "क्या हो अगर मेनू आपके पास आए? सब्सक्राइब करें, दिन ट्रैक करें, घर जाने पर पॉज करें — और वेंडर देखे कौन आया, कौन नहीं। SwaadIndia का जन्म हुआ।" },
      ],
      pull: "\"हर राइस प्लेट से पहले पहली सोच — SwaadIndia।\"",
    },
    studentFeatures: {
      label: "छात्रों और बैचलर्स के लिए",
      h: "आपका मेस,\nआपकी शर्तें।",
      tagline: "क्योंकि कमरे से निकलने से पहले आपको पता होना चाहिए कि क्या पकेगा।",
      features: [
        { n: "01", t: "एरिया से सर्च", d: "पुणे में पास के हर मेस और टिफिन को एक सर्च में खोजें।" },
        { n: "02", t: "वेज · नॉन-वेज फिल्टर", d: "एक टैप में फिल्टर करें। सिर्फ अपनी पसंद देखें।" },
        { n: "03", t: "लाइव मेनू अपडेट", d: "आज का राइस प्लेट — वेंडर तय करते ही आपको मिले।" },
        { n: "04", t: "30-दिन सब्सक्रिप्शन", d: "एक बार सब्सक्राइब करें। रोज खाएं। दिन ट्रैक करें।" },
        { n: "05", t: "प्लान पॉज करें", d: "घर जा रहे हैं? पॉज करें — हर बचा दिन आपका रहेगा।" },
        { n: "06", t: "उपस्थिति इतिहास", d: "किस दिन किस मेस में खाया — पूरी पारदर्शिता।" },
      ],
    },
    vendorFeatures: {
      label: "मेस मालिकों के लिए",
      h: "मेस चलाएं\nबिजनेस की तरह।",
      tagline: "WhatsApp पर मैनेज करना बंद करें। SwaadIndia पर शुरू करें।",
      features: [
        { n: "01", t: "लाइव डैशबोर्ड", d: "इन्क्वायरी काउंट, सर्विंग मोड, एक्टिव सब्सक्राइबर — एक नजर में।" },
        { n: "02", t: "आज का मेनू जोड़ें", d: "एक बार पोस्ट करें। हर सब्सक्राइबर तुरंत देखे।" },
        { n: "03", t: "स्पेशल मेनू", d: "फेस्टिवल थाली या स्पेशल — हर बार ज्यादा ग्राहक खींचें।" },
        { n: "04", t: "सब्सक्रिप्शन मैनेजमेंट", d: "हर ग्राहक का प्लान, रिन्यूअल, पॉज — एक स्क्रीन।" },
        { n: "05", t: "मेनू हिस्ट्री और रिपोर्ट", d: "क्या परोसा, क्या चला — मासिक एक्सपोर्ट ऑटोमेटिक।" },
        { n: "06", t: "QR उपस्थिति", d: "ग्राहक स्कैन करे, उपस्थिति दर्ज। कोई रजिस्टर नहीं।" },
      ],
    },
    attendance: {
      label: "उपस्थिति प्रणाली",
      h: "QR अंदर।\nकागज बाहर।",
      tagline: "दीवार पर लगी क्लिपबोर्ड से आपके फ़ोन पर लाइव डैशबोर्ड तक।",
      steps: [
        { n: "I", t: "QR बनाएं", d: "हर मेस को वेंडर डैशबोर्ड से यूनिक QR मिलता है।" },
        { n: "II", t: "ग्राहक स्कैन करे", d: "ग्राहक आए, स्कैन करे। एक सेकंड में उपस्थिति दर्ज।" },
        { n: "III", t: "लाइव व्यू", d: "Expected/Present/Absent रियल टाइम में। ब्रेकफास्ट, लंच, डिनर।" },
        { n: "IV", t: "ऑटो रिपोर्ट", d: "मासिक रिपोर्ट अपने आप बने। एक टैप में एक्सपोर्ट।" },
      ],
    },
    download: {
      label: "अभी शुरू करें",
      h: "एक सोच।\nएक ऐप।\nSwaadIndia।",
      sub: "पुणे के हजारों छात्रों और सैकड़ों मेस मालिकों से जुड़ें — जो कभी 'लंच में क्या है?' नहीं पूछते बिना जवाब जाने।",
      android: "Android के लिए डाउनलोड करें",
      ios: "iOS के लिए डाउनलोड करें",
      footer: "मुफ्त · English · हिंदी · मराठी",
    },
  },
  mr: {
    nav: ["कथा", "विद्यार्थ्यांसाठी", "विक्रेत्यांसाठी", "ॲप", "डाउनलोड"],
    langLabel: ["EN", "हि", "म"],
    hero: {
      eyebrow: "पुणे · महाराष्ट्र · भारत",
      tag: "भूक लागली की — SwaadIndia उत्तर देतो।",
      line1: "भूक लागण्यापूर्वीच,",
      line2: "आम्हाला माहीत असतं\nआज काय शिजतंय।",
      sub: "प्रत्येक राइस प्लेट. प्रत्येक थाळी. पुण्यातील प्रत्येक मेस — लाइव्ह अपडेट, तुमच्या फोनवर, बाहेर पडण्यापूर्वीच.",
      cta: "ॲप पाहा",
      scroll: "आमची कथा जाणा",
    },
    taglines: [
      { q: "\"चाला, बघा, निराश व्हा, परत करा।\"", a: "हे आज संपतं." },
      { q: "\"आज मेसमध्ये काय आहे?\"", a: "SwaadIndia उघडा. ३ सेकंदात जाणा." },
      { q: "\"जेवणात काय आहे?\"", a: "उत्तर नेहमी SwaadIndia आहे." },
    ],
    story: {
      label: "कथा",
      chapters: [
        { n: "01", title: "ती चाल जी कोणालाच नको", body: "दुपारी १२:३०. भूक लागली. मेसला गेलात — मेनू बदललेला, शटर अर्धे बंद, आणि रूममेट आधीच जाणत होता. तो SwaadIndia वापरतो." },
        { n: "02", title: "मेस मालकाची डोकेदुखी", body: "मोहन कोथरुडमध्ये मेस चालवतो. रोज WhatsApp वर विचारतात — 'आज काय करणार?' तो तीस वेळा एकच उत्तर टाइप करत असे. मग SwaadIndia मिळाले. एक पोस्ट. तीस विद्यार्थी माहित. झालं." },
        { n: "03", title: "ती कल्पना जी सारं बदलली", body: "मेनू तुमच्यापर्यंत आला तर? सबस्क्राइब करा, दिवस ट्रॅक करा, घरी गेल्यावर थांबवा — आणि विक्रेता पाहू शकेल कोण आले, कोण आले नाही. SwaadIndia जन्मला." },
      ],
      pull: "\"प्रत्येक राइस प्लेटपूर्वी पहिला विचार — SwaadIndia.\"",
    },
    studentFeatures: {
      label: "विद्यार्थी आणि बॅचलर्ससाठी",
      h: "तुमचे मेस,\nतुमच्या अटी.",
      tagline: "कारण खोलीतून बाहेर पडण्यापूर्वी तुम्हाला काय शिजतंय हे माहित असणं तुमचा हक्क आहे.",
      features: [
        { n: "01", t: "परिसरानुसार शोध", d: "पुण्यात जवळचे प्रत्येक मेस आणि टिफिन एका शोधात." },
        { n: "02", t: "व्हेज · नॉन-व्हेज फिल्टर", d: "एका टॅपमध्ये फिल्टर करा. फक्त तुमच्या आवडीचे पाहा." },
        { n: "03", t: "लाइव्ह मेनू अपडेट्स", d: "आजचे राइस प्लेट — विक्रेता ठरवताच तुम्हाला मिळते." },
        { n: "04", t: "30-दिवसांची सबस्क्रिप्शन", d: "एकदा सबस्क्राइब करा. रोज जेवा. दिवस ट्रॅक करा." },
        { n: "05", t: "योजना थांबवा", d: "घरी जात आहात? थांबवा — प्रत्येक न वापरलेला दिवस जपला जातो." },
        { n: "06", t: "हजेरी इतिहास", d: "कोणत्या दिवशी कोणत्या मेसमध्ये जेवलात — पूर्ण पारदर्शकता." },
      ],
    },
    vendorFeatures: {
      label: "मेस मालकांसाठी",
      h: "मेस चालवा\nव्यवसायासारखे.",
      tagline: "WhatsApp वर व्यवस्थापन थांबवा. SwaadIndia वर सुरू करा.",
      features: [
        { n: "01", t: "लाइव्ह डॅशबोर्ड", d: "चौकशी संख्या, सर्व्हिंग मोड, सक्रिय सबस्क्रायबर — एका नजरेत." },
        { n: "02", t: "आजचे मेनू जोडा", d: "एकदा पोस्ट करा. प्रत्येक सबस्क्रायबर लगेच पाहतो." },
        { n: "03", t: "स्पेशल मेनू", d: "सण थाळी किंवा स्पेशल — दर वेळी अधिक ग्राहक आकर्षित करा." },
        { n: "04", t: "सबस्क्रिप्शन व्यवस्थापन", d: "प्रत्येक ग्राहकाची योजना, नूतनीकरण, विराम — एका स्क्रीनवर." },
        { n: "05", t: "मेनू इतिहास आणि अहवाल", d: "काय वाढले, काय चालले — मासिक निर्यात स्वयंचलित." },
        { n: "06", t: "QR हजेरी", d: "ग्राहक स्कॅन करतो, हजेरी नोंदवली जाते. कोणतेही रजिस्टर नाही." },
      ],
    },
    attendance: {
      label: "हजेरी प्रणाली",
      h: "QR आत.\nकागद बाहेर.",
      tagline: "भिंतीवरील क्लिपबोर्डपासून तुमच्या फोनवरील लाइव्ह डॅशबोर्डपर्यंत.",
      steps: [
        { n: "I", t: "QR तयार करा", d: "प्रत्येक मेसला विक्रेता डॅशबोर्डवरून युनिक QR मिळतो." },
        { n: "II", t: "ग्राहक स्कॅन करतो", d: "ग्राहक येतो, स्कॅन करतो. एका सेकंदात हजेरी नोंद." },
        { n: "III", t: "लाइव्ह व्ह्यू", d: "Expected/Present/Absent रिअल टाइममध्ये. नाश्ता, दुपार, रात्र." },
        { n: "IV", t: "ऑटो अहवाल", d: "मासिक अहवाल आपोआप तयार. एका टॅपमध्ये निर्यात करा." },
      ],
    },
    download: {
      label: "आता सुरू करा",
      h: "एक विचार.\nएक ॲप.\nSwaadIndia.",
      sub: "पुण्यातील हजारो विद्यार्थी आणि शेकडो मेस मालकांमध्ये सामील व्हा — जे कधीही 'जेवणात काय?' विचारत नाहीत उत्तर माहीत नसताना.",
      android: "Android साठी डाउनलोड करा",
      ios: "iOS साठी डाउनलोड करा",
      footer: "मोफत · English · हिंदी · मराठी",
    },
  },
};

const LANG_CODES = ["en", "hi", "mr"];

/* ─── HOOKS ─── */
function useInView(threshold = 0.1) {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVis(true); obs.disconnect(); } },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, vis];
}

/* ─── SHARED COMPONENTS ─── */
function Reveal({ children, delay = 0, y = 30, style = {} }) {
  const [ref, vis] = useInView();
  return (
    <div ref={ref} style={{
      opacity: vis ? 1 : 0,
      transform: vis ? "translateY(0)" : `translateY(${y}px)`,
      transition: `opacity 0.9s cubic-bezier(.22,1,.36,1) ${delay}s, transform 0.9s cubic-bezier(.22,1,.36,1) ${delay}s`,
      ...style,
    }}>
      {children}
    </div>
  );
}

/* FIX 1: FeatureCell — removed the incorrect useState/lang lines that were added */
function FeatureCell({ n, t: title, d, dark = false }) {
  const [hover, setHover] = useState(false);
  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        borderRight: `1px solid ${dark ? "rgba(201,168,124,0.18)" : C.line}`,
        borderBottom: `1px solid ${dark ? "rgba(201,168,124,0.18)" : C.line}`,
        padding: "32px 28px",
        background: dark
          ? (hover ? "rgba(247,243,237,0.07)" : "transparent")
          : (hover ? C.parchment : "transparent"),
        transition: "background 0.4s",
        cursor: "default",
      }}
    >
      <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 38, fontWeight: 300, color: dark ? "rgba(201,168,124,0.22)" : C.line, lineHeight: 1, marginBottom: 12 }}>{n}</div>
      <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 18, fontWeight: 400, color: hover ? (dark ? C.gold : C.spice) : (dark ? "#F7F3ED" : C.dark), marginBottom: 8, transition: "color 0.3s" }}>{title}</div>
      <div style={{ fontFamily: "'Jost',sans-serif", fontWeight: 300, fontSize: 13, lineHeight: 1.75, color: dark ? "rgba(247,243,237,0.42)" : C.muted }}>{d}</div>
    </div>
  );
}

/* FIX 2: DlButton as proper component — no more useState inside map */
function DlButton({ label, icon, primary = false }) {
  const [hover, setHover] = useState(false);
  return (
    <button
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        display: "flex", alignItems: "center", gap: 12,
        background: primary ? (hover ? C.gold : C.saffron) : (hover ? "rgba(247,243,237,0.07)" : "transparent"),
        border: primary ? "none" : "1px solid rgba(247,243,237,0.22)",
        color: primary ? "#fff" : "rgba(247,243,237,0.75)",
        padding: "17px 36px",
        fontFamily: "'Jost',sans-serif", fontWeight: 400, fontSize: 12,
        letterSpacing: "0.18em", textTransform: "uppercase",
        cursor: "pointer", transition: "all 0.35s",
      }}
    >
      <span style={{ fontSize: 18 }}>{icon}</span>{label}
    </button>
  );
}

function PhoneMockup({ screen }) {
  return (
    <div style={{ width: 240, height: 480, background: "#111", borderRadius: 36, border: "2px solid #333", boxShadow: "0 40px 80px rgba(0,0,0,0.45)", position: "relative", overflow: "hidden", flexShrink: 0 }}>
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, overflow: "hidden" }}>
        {screen}
      </div>
      <div style={{ position: "absolute", top: 10, left: "50%", transform: "translateX(-50%)", width: 60, height: 5, background: "#333", borderRadius: 3 }} />
    </div>
  );
}

/* ─── APP SCREENS ─── */
function HomeScreen() {
  return (
    <div style={{ background: "#F0F4F0", height: "100%", fontFamily: "sans-serif", paddingTop: 14, fontSize: 11 }}>
      <div style={{ background: C.green, padding: "12px 14px 16px", borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
          <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#FFD700", border: "2px solid #fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "#333" }}>MO</div>
          <div>
            <div style={{ fontSize: 9, color: "rgba(255,255,255,0.7)" }}>Welcome</div>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>Rahul</div>
          </div>
          <div style={{ marginLeft: "auto", display: "flex", gap: 6 }}>
            <div style={{ width: 26, height: 26, borderRadius: "50%", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12 }}>🔔</div>
            <div style={{ width: 26, height: 26, borderRadius: "50%", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12 }}>⚙️</div>
          </div>
        </div>
        <div style={{ background: "rgba(255,255,255,0.2)", borderRadius: 8, padding: "5px 10px", fontSize: 9, color: "#fff" }}>Thursday, Apr 9, 2026</div>
      </div>
      <div style={{ padding: "10px 12px" }}>
        <div style={{ background: "#fff", borderRadius: 10, padding: "8px 10px", display: "flex", alignItems: "center", gap: 6, marginBottom: 8, border: "1px solid #eee" }}>
          <span style={{ fontSize: 12 }}>🔍</span>
          <span style={{ fontSize: 10, color: "#aaa" }}>Search area / Hotel / Mess</span>
        </div>
        <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
          <div style={{ background: "#fff", borderRadius: 8, padding: "5px 10px", fontSize: 9, border: "1px solid #ddd", display: "flex", alignItems: "center", gap: 4 }}>📍 Pune ▾</div>
          <div style={{ background: "#E53935", borderRadius: 20, padding: "5px 12px", fontSize: 9, color: "#fff", fontWeight: 700 }}>Non-Veg</div>
          <div style={{ background: "#fff", borderRadius: 20, padding: "5px 12px", fontSize: 9, color: "#555", border: "1px solid #ddd" }}>Pure Veg</div>
        </div>
        <div style={{ background: "#1C2B1C", borderRadius: 14, padding: "10px 12px", marginBottom: 8 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
            <div>
              <div style={{ fontSize: 8, color: C.green, fontWeight: 700, letterSpacing: "0.1em" }}>ACTIVE PLAN</div>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#fff" }}>Your Mess</div>
              <div style={{ background: C.green, borderRadius: 4, padding: "2px 6px", fontSize: 8, color: "#fff", display: "inline-block", marginTop: 2 }}>LUNCH</div>
            </div>
            <div style={{ background: "rgba(255,255,255,0.1)", borderRadius: 8, padding: "4px 8px", fontSize: 8, color: "#fff" }}>⏸ Pause</div>
          </div>
          <div style={{ fontSize: 8, color: "rgba(255,255,255,0.5)", marginBottom: 4 }}>Days Progress · 0%</div>
          <div style={{ background: "rgba(255,255,255,0.1)", borderRadius: 4, height: 4, marginBottom: 8 }}>
            <div style={{ background: C.green, width: "5%", height: "100%", borderRadius: 4 }} />
          </div>
          <div style={{ display: "flex", justifyContent: "space-around", background: "rgba(0,0,0,0.3)", borderRadius: 8, padding: "6px 0" }}>
            {[["0", "Used", null], ["30", "Remaining", "#4CAF50"], ["30", "Total", null]].map(([v, l, co]) => (
              <div key={l} style={{ textAlign: "center" }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: co || "#fff" }}>{v}</div>
                <div style={{ fontSize: 8, color: "rgba(255,255,255,0.4)" }}>{l}</div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ fontSize: 10, fontWeight: 700, color: "#333", marginBottom: 6 }}>Available Vendors</div>
        <div style={{ background: "#fff", borderRadius: 12, padding: "10px 12px", border: "1px solid #eee" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#222" }}>Sharma Mess</div>
              <div style={{ fontSize: 8, color: "#888", marginTop: 2 }}>👤 Owner: Sharma · 📍 Kothrud, Pune</div>
              <div style={{ fontSize: 8, color: "#888", marginTop: 1 }}>🍽 Veg / Non Veg</div>
            </div>
            <div style={{ display: "flex", gap: 6 }}>
              <span style={{ fontSize: 14 }}>⭐</span>
              <span style={{ fontSize: 14 }}>↗</span>
            </div>
          </div>
          <div style={{ background: C.green, borderRadius: 6, padding: "4px 8px", fontSize: 8, color: "#fff", marginTop: 6, display: "inline-block" }}>Monthly Subscription (₹2000)</div>
        </div>
      </div>
    </div>
  );
}

function VendorDashScreen() {
  return (
    <div style={{ background: "#EEF3EE", height: "100%", fontFamily: "sans-serif", paddingTop: 14, fontSize: 11 }}>
      <div style={{ padding: "0 12px 10px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
          <div style={{ width: 32, height: 32, borderRadius: "50%", background: C.green, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "#fff" }}>MO</div>
          <div>
            <div style={{ fontSize: 9, color: "#888" }}>welcome,</div>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#222" }}>Sharma mess</div>
          </div>
          <div style={{ marginLeft: "auto", display: "flex", gap: 6 }}>
            <span style={{ fontSize: 14 }}>🔔</span>
            <span style={{ fontSize: 14 }}>⚙️</span>
          </div>
        </div>
        <div style={{ background: "#fff", borderRadius: 14, padding: "10px 12px", marginBottom: 8, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ fontSize: 9, color: "#999", letterSpacing: "0.08em" }}>INTEREST TODAY</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#222", marginBottom: 4 }}>47 Inquiries</div>
          <div style={{ background: "#f0f0f0", borderRadius: 4, height: 4 }}>
            <div style={{ background: C.green, width: "60%", height: "100%", borderRadius: 4 }} />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 4 }}>
            <div style={{ background: "#FFF0E0", borderRadius: 10, padding: "2px 8px", fontSize: 8, color: "#D4863A" }}>Today</div>
          </div>
        </div>
        <div style={{ background: "#fff", borderRadius: 14, padding: "10px 12px", marginBottom: 8, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: "#222", marginBottom: 2 }}>Current Status</div>
          <div style={{ fontSize: 8, color: "#888", marginBottom: 6 }}>Thursday, 09 Apr, 2026</div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontSize: 9, fontWeight: 700, color: "#333", letterSpacing: "0.05em" }}>SERVING MODE</div>
            <div style={{ width: 36, height: 20, background: "#FFB300", borderRadius: 10, position: "relative" }}>
              <div style={{ width: 16, height: 16, background: "#fff", borderRadius: "50%", position: "absolute", right: 2, top: 2 }} />
            </div>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          {[["🍽", "ADD MENU", "#444"], ["⭐", "SPECIAL MENU", "#D4863A"], ["👥", "ATTENDANCE", "#3B82F6"], ["💳", "SUBSCRIPTIONS", "#7C3AED"], ["🕐", "MENU HISTORY", "#E53935"], ["📊", "REPORTS", "#2D7A3A"]].map(([ic, lb, co]) => (
            <div key={lb} style={{ background: "#fff", borderRadius: 12, padding: "12px 10px", textAlign: "center", boxShadow: "0 2px 6px rgba(0,0,0,0.05)", borderLeft: `3px solid ${co}` }}>
              <div style={{ fontSize: 20, marginBottom: 4 }}>{ic}</div>
              <div style={{ fontSize: 8, fontWeight: 700, color: "#333", letterSpacing: "0.06em" }}>{lb}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function MenuScreen() {
  return (
    <div style={{ background: "#F5F5F5", height: "100%", fontFamily: "sans-serif", paddingTop: 14 }}>
      <div style={{ background: "#fff", padding: "10px 14px", display: "flex", alignItems: "center", borderBottom: "1px solid #eee" }}>
        <span style={{ fontSize: 16 }}>←</span>
        <div style={{ flex: 1, textAlign: "center", fontSize: 13, fontWeight: 700, color: "#222" }}>Sharma mess</div>
      </div>
      <div style={{ padding: "10px 12px" }}>
        <div style={{ background: C.green, borderRadius: 10, padding: "10px 14px", textAlign: "center", marginBottom: 10 }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: "#fff" }}>Monthly Subscription Click Here</div>
        </div>
        <div style={{ display: "flex", background: "#fff", borderRadius: 10, marginBottom: 8, overflow: "hidden" }}>
          <div style={{ flex: 1, padding: "8px 0", textAlign: "center", fontSize: 10, fontWeight: 700, color: C.saffron, borderBottom: `2px solid ${C.saffron}` }}>Today's Menu</div>
          <div style={{ flex: 1, padding: "8px 0", textAlign: "center", fontSize: 10, color: "#888" }}>Special Menu</div>
        </div>
        <div style={{ fontSize: 9, color: "#888", marginBottom: 8 }}>Found 1 menu for today</div>
        <div style={{ background: "#FEFAF3", borderRadius: 14, padding: "14px 12px", border: "1px solid #E8D5A3" }}>
          <div style={{ textAlign: "center", marginBottom: 8 }}>
            <div style={{ fontSize: 10, color: "#8B6914", letterSpacing: "0.1em" }}>✦ ——————— ✦</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: "#222", marginTop: 4 }}>Rice plate</div>
            <div style={{ fontSize: 9, color: "#888", fontStyle: "italic", marginTop: 2 }}>"3 chapati, 2 bhaji, Bhaat, Dal"</div>
          </div>
          <div style={{ background: "#EEF5FF", borderRadius: 8, padding: "8px 10px", marginBottom: 8 }}>
            <div style={{ fontSize: 9, fontWeight: 700, color: "#3B82F6", marginBottom: 4 }}>🍽 What's Included:</div>
            {["Shevbhaji", "Soyabean"].map(item => (
              <div key={item} style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 3 }}>
                <span style={{ color: C.green, fontSize: 10 }}>✅</span>
                <span style={{ fontSize: 9, color: "#333" }}>{item}</span>
              </div>
            ))}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div style={{ fontSize: 8, color: "#999" }}>Price</div>
              <div style={{ fontSize: 18, fontWeight: 800, color: C.green }}>₹70</div>
            </div>
            <div style={{ background: "#3B82F6", borderRadius: 8, padding: "8px 16px", fontSize: 10, fontWeight: 700, color: "#fff" }}>ADD</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function AttendanceScreen() {
  return (
    <div style={{ background: "#F5F5F5", height: "100%", fontFamily: "sans-serif", paddingTop: 14 }}>
      <div style={{ padding: "0 12px 10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#222" }}>Attendance Dashboard</div>
            <div style={{ fontSize: 9, color: "#888" }}>Thursday, 09 Apr, 2026</div>
          </div>
          <div style={{ background: "#3B82F6", borderRadius: 10, padding: "6px 8px", fontSize: 16 }}>📱</div>
        </div>
        <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
          {[["0", "Expected", "#3B82F6"], ["32", "Present", "#2D7A3A"], ["8", "Absent", "#E53935"], ["2", "Late", "#FFB300"]].map(([v, l, bg]) => (
            <div key={l} style={{ flex: 1, background: bg, borderRadius: 10, padding: "8px 4px", textAlign: "center" }}>
              <div style={{ fontSize: 16, fontWeight: 700, color: "#fff" }}>{v}</div>
              <div style={{ fontSize: 7, color: "rgba(255,255,255,0.8)" }}>{l}</div>
            </div>
          ))}
        </div>
        <div style={{ display: "flex", background: "#fff", borderRadius: 10, marginBottom: 8, padding: 3, gap: 3 }}>
          {[["🌅", "Breakfast"], ["☀️", "Lunch"], ["🌙", "Dinner"]].map(([ic, lb], i) => (
            <div key={lb} style={{ flex: 1, background: i === 1 ? "#3B82F6" : "transparent", borderRadius: 8, padding: "6px 0", textAlign: "center" }}>
              <span style={{ fontSize: 10 }}>{ic}</span>
              <div style={{ fontSize: 8, fontWeight: i === 1 ? 700 : 400, color: i === 1 ? "#fff" : "#888" }}>{lb}</div>
            </div>
          ))}
        </div>
        <div style={{ background: "#fff", borderRadius: 10, padding: "8px 10px", marginBottom: 8, display: "flex", alignItems: "center", gap: 6, border: "1px solid #eee" }}>
          <span style={{ fontSize: 12 }}>🔍</span>
          <span style={{ fontSize: 9, color: "#aaa" }}>Search by name or phone...</span>
        </div>
        {[{ n: "Nilesh", p: "9999999999", s: "Present" }, { n: "Priya", p: "9876543210", s: "Absent" }, { n: "Rahul", p: "9988776655", s: "Present" }].map(u => (
          <div key={u.n} style={{ background: "#fff", borderRadius: 10, padding: "8px 10px", marginBottom: 6, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#7C3AED", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, color: "#fff" }}>{u.n[0]}</div>
              <div>
                <div style={{ fontSize: 10, fontWeight: 700, color: "#222" }}>{u.n}</div>
                <div style={{ fontSize: 8, color: "#888" }}>{u.p}</div>
              </div>
            </div>
            <div style={{ background: u.s === "Present" ? "#E8F5E9" : "#FFEBEE", borderRadius: 8, padding: "4px 10px", fontSize: 8, fontWeight: 700, color: u.s === "Present" ? C.green : "#E53935" }}>{u.s}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ─── MAIN APP ─── */
export default function App() {
  const [lang, setLang] = useState("en");
  const [scrollY, setScrollY] = useState(0);
  const t = T[lang];
  const navSolid = scrollY > 60;

  useEffect(() => {
    const fn = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    const s = document.createElement("style");
    s.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Jost:wght@300;400;500&display=swap');
      html { scroll-behavior: smooth; }
      * { margin: 0; padding: 0; box-sizing: border-box; }
      body { background: #eed8b6; color: #1A120A; font-family: 'Jost', sans-serif; overflow-x: hidden; }
      ::selection { background: #8B5E3C33; }
      ::-webkit-scrollbar { width: 3px; }
      ::-webkit-scrollbar-track { background: #eed8b6; }
      ::-webkit-scrollbar-thumb { background: #C9A87C; }
    `;
    document.head.appendChild(s);
    return () => document.head.removeChild(s);
  }, []);

  const scrollTo = id => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <div style={{ background: C.cream, color: C.dark, fontFamily: "'Jost',sans-serif", overflowX: "hidden" }}>

      {/* NAV */}
      <nav style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 200, padding: "0 5%", height: 68,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        background: navSolid ? "rgba(238,216,182,0.96)" : "transparent",
        backdropFilter: navSolid ? "blur(20px)" : "none",
        borderBottom: navSolid ? `1px solid ${C.line}` : "none",
        transition: "all 0.5s ease",
      }}>
        <button onClick={() => scrollTo("hero")} style={{ background: "none", border: "none", cursor: "pointer", textAlign: "left" }}>
          <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, fontWeight: 600, color: C.dark, letterSpacing: "0.04em", lineHeight: 1 }}>
            Swaad<span style={{ color: C.saffron }}>India</span>
          </div>
          <div style={{ fontSize: 9, fontWeight: 300, color: C.muted, letterSpacing: "0.22em", textTransform: "uppercase", marginTop: 2 }}>Pune · Est. 2024</div>
        </button>
        <div style={{ display: "flex", alignItems: "center", gap: 28 }}>
          {["story", "students", "vendors", "app", "download"].map((id, i) => (
            <button key={id} onClick={() => scrollTo(id)} style={{ background: "none", border: "none", cursor: "pointer", fontFamily: "'Jost',sans-serif", fontWeight: 300, fontSize: 12, letterSpacing: "0.16em", textTransform: "uppercase", color: C.muted, transition: "color 0.3s" }}
              onMouseOver={e => e.target.style.color = C.spice}
              onMouseOut={e => e.target.style.color = C.muted}
            >{t.nav[i]}</button>
          ))}
          <div style={{ display: "flex", gap: 2, borderLeft: `1px solid ${C.line}`, paddingLeft: 16 }}>
            {LANG_CODES.map((code, i) => (
              <button key={code} onClick={() => setLang(code)} style={{ background: "none", border: "none", cursor: "pointer", fontFamily: "'Jost',sans-serif", fontWeight: lang === code ? 500 : 300, fontSize: 11, letterSpacing: "0.1em", padding: "4px 8px", color: lang === code ? C.saffron : C.muted, borderBottom: `1px solid ${lang === code ? C.saffron : "transparent"}`, transition: "all 0.25s" }}>{t.langLabel[i]}</button>
            ))}
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section id="hero" style={{ minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", padding: "110px 5% 100px", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: 68, left: "5%", right: "5%", height: 1, background: C.line }} />
        <div style={{ position: "absolute", bottom: -30, right: -20, fontFamily: "'Cormorant Garamond',serif", fontSize: "min(300px,28vw)", fontWeight: 300, lineHeight: 0.85, color: "transparent", WebkitTextStroke: `1px ${C.line}`, pointerEvents: "none", opacity: Math.max(0, 1 - scrollY / 500), letterSpacing: "-0.03em" }}>स्वाद</div>
        <div style={{ maxWidth: 1200, width: "100%", margin: "0 auto" }}>
          <Reveal delay={0.05}>
            <p style={{ fontSize: 11, fontWeight: 300, letterSpacing: "0.28em", textTransform: "uppercase", color: C.muted, marginBottom: 16 }}>{t.hero.eyebrow}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 10, background: `${C.saffron}18`, border: `1px solid ${C.saffron}44`, borderRadius: 100, padding: "8px 20px", marginBottom: 36 }}>
              <span style={{ fontSize: 16 }}>🍛</span>
              <span style={{ fontFamily: "'Jost',sans-serif", fontWeight: 400, fontSize: 14, color: C.saffron, fontStyle: "italic" }}>{t.hero.tag}</span>
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 300, fontSize: "clamp(44px,8vw,108px)", lineHeight: 0.95, letterSpacing: "-0.025em", marginBottom: 6, color: C.dark }}>{t.hero.line1}</h1>
            <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 300, fontStyle: "italic", fontSize: "clamp(44px,8vw,108px)", lineHeight: 0.95, letterSpacing: "-0.025em", color: C.saffron, marginBottom: 44, whiteSpace: "pre-line" }}>{t.hero.line2}</h1>
          </Reveal>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48, alignItems: "flex-end" }}>
            <Reveal delay={0.38}>
              <p style={{ fontFamily: "'Jost',sans-serif", fontWeight: 300, fontSize: 17, lineHeight: 1.9, color: C.muted, maxWidth: 430 }}>{t.hero.sub}</p>
            </Reveal>
            <Reveal delay={0.5} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 20 }}>
              <button onClick={() => scrollTo("app")} style={{ fontFamily: "'Jost',sans-serif", fontWeight: 400, fontSize: 12, letterSpacing: "0.22em", textTransform: "uppercase", color: C.dark, background: "none", border: `1px solid ${C.dark}`, padding: "17px 42px", cursor: "pointer", transition: "all 0.4s" }}
                onMouseOver={e => { e.target.style.background = C.dark; e.target.style.color = C.cream; }}
                onMouseOut={e => { e.target.style.background = "none"; e.target.style.color = C.dark; }}
              >{t.hero.cta}</button>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ width: 36, height: 1, background: C.muted }} />
                <span style={{ fontSize: 10, fontWeight: 300, letterSpacing: "0.18em", textTransform: "uppercase", color: C.muted }}>{t.hero.scroll}</span>
              </div>
            </Reveal>
          </div>
        </div>
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, borderTop: `1px solid ${C.line}`, display: "flex", justifyContent: "center" }}>
          {[["500+", "Mess Partners"], ["10,000+", "Students"], ["3", "Cities Live"]].map(([n, l], i) => (
            <div key={l} style={{ padding: "18px 56px", borderLeft: i > 0 ? `1px solid ${C.line}` : "none", textAlign: "center" }}>
              <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 24, fontWeight: 400, color: C.saffron }}>{n}</div>
              <div style={{ fontSize: 9, fontWeight: 300, letterSpacing: "0.22em", textTransform: "uppercase", color: C.muted, marginTop: 3 }}>{l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* TAGLINE BAND */}
      <div style={{ background: C.dark, padding: "80px 5%" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(3,1fr)", borderLeft: "1px solid rgba(201,168,124,0.2)" }}>
          {t.taglines.map((tl, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div style={{ padding: "32px 36px", borderRight: "1px solid rgba(201,168,124,0.2)" }}>
                <p style={{ fontFamily: "'Cormorant Garamond',serif", fontStyle: "italic", fontSize: 20, fontWeight: 300, color: "rgba(247,243,237,0.55)", lineHeight: 1.5, marginBottom: 14 }}>{tl.q}</p>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 20, height: 1, background: C.saffron }} />
                  <p style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, fontWeight: 600, color: C.saffron }}>{tl.a}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* STORY */}
      <section id="story" style={{ padding: "130px 5%", background: C.parchment, position: "relative" }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 1, background: C.line }} />
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <Reveal>
            <div style={{ textAlign: "center", marginBottom: 72 }}>
              <p style={{ fontSize: 9, letterSpacing: "0.32em", textTransform: "uppercase", color: C.gold, marginBottom: 14 }}>{t.story.label}</p>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16 }}>
                <div style={{ height: 1, width: 60, background: C.line }} />
                <span style={{ fontSize: 20 }}>🍛</span>
                <div style={{ height: 1, width: 60, background: C.line }} />
              </div>
            </div>
          </Reveal>
          <div style={{ borderTop: `1px solid ${C.line}`, borderLeft: `1px solid ${C.line}` }}>
            {t.story.chapters.map((ch, i) => (
              <Reveal key={ch.n} delay={i * 0.1}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", borderRight: `1px solid ${C.line}`, borderBottom: `1px solid ${C.line}` }}>
                  <div style={{ padding: "40px 36px", borderRight: `1px solid ${C.line}` }}>
                    <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 52, fontWeight: 300, color: C.line, lineHeight: 1 }}>{ch.n}</div>
                    <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, fontWeight: 400, color: C.dark, marginTop: 8, lineHeight: 1.3 }}>{ch.title}</div>
                  </div>
                  <div style={{ padding: "40px 36px", display: "flex", alignItems: "center" }}>
                    <p style={{ fontFamily: "'Jost',sans-serif", fontWeight: 300, fontSize: 16, lineHeight: 1.9, color: C.charcoal }}>{ch.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <div style={{ marginTop: 56, textAlign: "center", padding: "40px 60px", background: C.dark, borderRadius: 4 }}>
              <p style={{ fontFamily: "'Cormorant Garamond',serif", fontStyle: "italic", fontSize: 28, fontWeight: 300, color: C.cream, lineHeight: 1.5 }}>{t.story.pull}</p>
            </div>
          </Reveal>
        </div>
      </section>

      {/* STUDENTS */}
      <section id="students" style={{ padding: "130px 5%", background: C.cream }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 72, alignItems: "flex-start", marginBottom: 64 }}>
            <Reveal>
              <p style={{ fontSize: 9, letterSpacing: "0.32em", textTransform: "uppercase", color: C.gold, marginBottom: 16 }}>{t.studentFeatures.label}</p>
              <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 400, fontSize: "clamp(36px,4.5vw,60px)", lineHeight: 1.05, letterSpacing: "-0.02em", whiteSpace: "pre-line", marginBottom: 20 }}>{t.studentFeatures.h}</h2>
              <p style={{ fontFamily: "'Jost',sans-serif", fontWeight: 300, fontStyle: "italic", fontSize: 16, color: C.muted, lineHeight: 1.7 }}>{t.studentFeatures.tagline}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <div style={{ display: "flex", justifyContent: "center", gap: 20 }}>
                <div style={{ transform: "rotate(-3deg) translateY(10px)" }}>
                  <PhoneMockup screen={<HomeScreen />} />
                </div>
                <div style={{ transform: "rotate(2deg) translateY(-10px)" }}>
                  <PhoneMockup screen={<MenuScreen />} />
                </div>
              </div>
            </Reveal>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", borderTop: `1px solid ${C.line}`, borderLeft: `1px solid ${C.line}` }}>
            {t.studentFeatures.features.map((f, i) => (
              <Reveal key={f.t} delay={i * 0.06}><FeatureCell n={f.n} t={f.t} d={f.d} /></Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* VENDORS */}
      <section id="vendors" style={{ padding: "130px 5%", background: C.charcoal, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -80, right: -80, width: 500, height: 500, borderRadius: "50%", border: "1px solid rgba(201,168,124,0.07)", pointerEvents: "none" }} />
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 72, alignItems: "flex-start", marginBottom: 64 }}>
            <Reveal>
              <p style={{ fontSize: 9, letterSpacing: "0.32em", textTransform: "uppercase", color: C.gold, marginBottom: 16 }}>{t.vendorFeatures.label}</p>
              <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 300, fontSize: "clamp(36px,5vw,64px)", lineHeight: 1, letterSpacing: "-0.025em", color: "#F8F4EE", whiteSpace: "pre-line", marginBottom: 20 }}>{t.vendorFeatures.h}</h2>
              <p style={{ fontFamily: "'Jost',sans-serif", fontWeight: 300, fontStyle: "italic", fontSize: 16, color: "rgba(247,243,237,0.5)", lineHeight: 1.7 }}>{t.vendorFeatures.tagline}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <div style={{ display: "flex", justifyContent: "center", gap: 20 }}>
                <div style={{ transform: "rotate(-2deg) translateY(8px)" }}>
                  <PhoneMockup screen={<VendorDashScreen />} />
                </div>
                <div style={{ transform: "rotate(3deg) translateY(-8px)" }}>
                  <PhoneMockup screen={<AttendanceScreen />} />
                </div>
              </div>
            </Reveal>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", borderTop: "1px solid rgba(201,168,124,0.18)", borderLeft: "1px solid rgba(201,168,124,0.18)" }}>
            {t.vendorFeatures.features.map((f, i) => (
              <Reveal key={f.t} delay={i * 0.06}><FeatureCell n={f.n} t={f.t} d={f.d} dark /></Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* APP SCREENS SHOWCASE */}
      <section id="app" style={{ padding: "130px 5%", background: C.parchment, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 1, background: C.line }} />
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <Reveal>
            <div style={{ textAlign: "center", marginBottom: 72 }}>
              <p style={{ fontSize: 9, letterSpacing: "0.32em", textTransform: "uppercase", color: C.gold, marginBottom: 20 }}>The App</p>
              <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 400, fontSize: "clamp(38px,5.5vw,68px)", lineHeight: 1, letterSpacing: "-0.025em" }}>
                Everything you need.<br />
                <span style={{ fontStyle: "italic", color: C.saffron }}>Nothing you don't.</span>
              </h2>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end", gap: 24, flexWrap: "wrap" }}>
              {[
                { screen: <HomeScreen />, label: "Student Home", rot: "rotate(-4deg) translateY(20px)" },
                { screen: <VendorDashScreen />, label: "Vendor Dashboard", rot: "rotate(-1deg) translateY(0px)" },
                { screen: <MenuScreen />, label: "Today's Menu", rot: "rotate(2deg) translateY(10px)" },
                { screen: <AttendanceScreen />, label: "Attendance", rot: "rotate(4deg) translateY(18px)" },
              ].map(({ screen, label, rot }) => (
                <div key={label} style={{ transform: rot }}>
                  <PhoneMockup screen={screen} />
                  <div style={{ textAlign: "center", marginTop: 16, fontSize: 11, color: C.muted, fontStyle: "italic" }}>{label}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* ATTENDANCE */}
      <section id="attendance" style={{ padding: "130px 5%", background: C.cream, position: "relative" }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 1, background: C.line }} />
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 90, alignItems: "flex-start" }}>
          <div>
            <Reveal>
              <p style={{ fontSize: 9, letterSpacing: "0.32em", textTransform: "uppercase", color: C.gold, marginBottom: 16 }}>{t.attendance.label}</p>
              <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 400, fontSize: "clamp(36px,4.5vw,58px)", lineHeight: 1.05, letterSpacing: "-0.02em", whiteSpace: "pre-line", marginBottom: 16 }}>{t.attendance.h}</h2>
              <p style={{ fontFamily: "'Jost',sans-serif", fontWeight: 300, fontStyle: "italic", fontSize: 16, color: C.muted, lineHeight: 1.7, marginBottom: 36 }}>{t.attendance.tagline}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
                <div style={{ width: 130, height: 130, background: C.parchment, border: `2px solid ${C.gold}`, borderRadius: 14, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 5, boxShadow: `0 0 0 8px ${C.cream}, 0 0 0 9px ${C.line}` }}>
                  <div style={{ fontSize: 54, lineHeight: 1 }}>📱</div>
                  <div style={{ fontSize: 8, color: C.spice, letterSpacing: "0.22em", textTransform: "uppercase" }}>Scan to enter</div>
                </div>
                <div style={{ fontSize: 9, color: C.muted, letterSpacing: "0.18em", textTransform: "uppercase" }}>Swaad QR · Unique per mess</div>
              </div>
            </Reveal>
          </div>
          <div style={{ borderLeft: `1px solid ${C.line}`, paddingLeft: 56 }}>
            {t.attendance.steps.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.1}>
                <div style={{ paddingBottom: 30, marginBottom: 30, borderBottom: i < 3 ? `1px solid ${C.line}` : "none" }}>
                  <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 42, fontWeight: 300, color: C.line, lineHeight: 1, marginBottom: 8 }}>{s.n}</div>
                  <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, fontWeight: 400, color: C.dark, marginBottom: 6 }}>{s.t}</div>
                  <div style={{ fontFamily: "'Jost',sans-serif", fontWeight: 300, fontSize: 14, color: C.muted, lineHeight: 1.75 }}>{s.d}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* DOWNLOAD */}
      <section id="download" style={{ padding: "160px 5%", background: C.dark, position: "relative", overflow: "hidden", textAlign: "center" }}>
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", fontFamily: "'Cormorant Garamond',serif", fontSize: "min(340px,26vw)", fontWeight: 300, color: "transparent", WebkitTextStroke: "1px rgba(201,168,124,0.06)", pointerEvents: "none", whiteSpace: "nowrap", letterSpacing: "-0.03em" }}>स्वाद</div>
        <div style={{ position: "relative", maxWidth: 700, margin: "0 auto" }}>
          <Reveal>
            <p style={{ fontSize: 9, letterSpacing: "0.32em", textTransform: "uppercase", color: C.gold, marginBottom: 28 }}>{t.download.label}</p>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16, marginBottom: 28 }}>
              <div style={{ height: 1, width: 50, background: "rgba(201,168,124,0.3)" }} />
              <span style={{ fontSize: 26 }}>🍛</span>
              <div style={{ height: 1, width: 50, background: "rgba(201,168,124,0.3)" }} />
            </div>
            <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 300, fontStyle: "italic", fontSize: "clamp(44px,8vw,100px)", lineHeight: 1, letterSpacing: "-0.03em", color: C.cream, marginBottom: 32, whiteSpace: "pre-line" }}>{t.download.h}</h2>
            <p style={{ fontFamily: "'Jost',sans-serif", fontWeight: 300, fontSize: 16, color: "rgba(247,243,237,0.44)", lineHeight: 1.85, marginBottom: 52 }}>{t.download.sub}</p>
            {/* FIX 3: Using DlButton component instead of useState inside map */}
            <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap", marginBottom: 24 }}>
              <DlButton label={t.download.android} icon="🤖" primary />
              <DlButton label={t.download.ios} icon="🍎" />
            </div>
            <p style={{ fontSize: 10, color: "rgba(247,243,237,0.2)", letterSpacing: "0.15em", textTransform: "uppercase" }}>{t.download.footer}</p>
          </Reveal>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ background: "#0E0A06", borderTop: "1px solid rgba(201,168,124,0.12)", padding: "36px 5%", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 14 }}>
        <div>
          <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 18, fontWeight: 600, color: C.cream, letterSpacing: "0.04em" }}>Swaad<span style={{ color: C.saffron }}>India</span></span>
          <span style={{ fontSize: 9, color: "rgba(247,243,237,0.18)", marginLeft: 14, letterSpacing: "0.2em", textTransform: "uppercase" }}>Pune · 2024</span>
        </div>
        <p style={{ fontSize: 11, color: "rgba(247,243,237,0.18)", fontWeight: 300 }}>Made with love for every hungry student in India.</p>
        <div style={{ display: "flex", gap: 22 }}>
          {["Privacy", "Terms", "Contact"].map(l => (
            <span key={l} style={{ fontSize: 10, color: "rgba(247,243,237,0.22)", cursor: "pointer", letterSpacing: "0.12em", textTransform: "uppercase" }}>{l}</span>
          ))}
        </div>
      </footer>

    </div>
  );
}